import type { ImageTransformationKind } from "../types";
import { getImageTransformationsProvider } from "./providers";

export function buildImageCDNUrl(
  key: string,
  kind?: ImageTransformationKind,
): string {
  const provider = getImageTransformationsProvider();

  if (
    process.env.NEXT_PUBLIC_CDN_BASE_URL &&
    key.startsWith(process.env.NEXT_PUBLIC_CDN_BASE_URL)
  ) {
    // full CDN URL provided, we can just replace it with the transofmration URL
    return provider.convertToTransformationUrl(key, kind);
  }

  if (key.startsWith("http")) {
    // external URL provided, can't transform it, so we'll just return it as is
    return key;
  }

  // R2 bucket key provided, build the transformation URL from it
  return provider.buildImageCDNUrl(key, kind);
}

export function isTransformationUrl(url: string): boolean {
  const provider = getImageTransformationsProvider();
  return provider.isTransformationUrl(url);
}
